import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetIrregularOceanStudents, IGetOceanStudents, IGetRegularOcean, IGetRegularOceans, IGetRegularOceanStudents, IOceanStudentParams, IOceanStudentReq, IRegularOceanReq } from '../models/oceanManagement.model';
import QueryString from 'qs';

const uri = '/mgmt/ocean-management';

export const getRegularOceans = (): AxiosPromise<IGetRegularOceans> => {
  return axios.get(`${uri}/regular-exam`);
}

export const getRegularOcean = (scheduleCode: number): AxiosPromise<IGetRegularOcean> => {
  return axios.get(`${uri}/regular-exam/${scheduleCode}`);
}

export const createRegularOcean = (data: IRegularOceanReq): AxiosPromise => {
  return axios.post(`${uri}/regular-exam`, data);
}

export const updateRegularOcean = (scheduleCode: number, data: IRegularOceanReq): AxiosPromise => {
  return axios.put(`${uri}/regular-exam/${scheduleCode}`, data);
}

export const getRegularOceanStudents = (scheduleCode: number): AxiosPromise<IGetRegularOceanStudents> => {
  return axios.get(`${uri}/regular-exam/student/${scheduleCode}`);
}

export const getOceanStudents = (campusCode: string, params: IOceanStudentParams): AxiosPromise<IGetOceanStudents> => {
  return axios.get(`${uri}/${campusCode}/student-list`, { params });
};

export const createOceanStudent = (data: IOceanStudentReq): AxiosPromise => {
  return axios.post(`${uri}/ocean-test`, data);
}

export const deleteOceanStudent = (testNo: number): AxiosPromise => {
  return axios.put(`${uri}/require/${testNo}`);
}

export const getIrregularOceanStudents = (): AxiosPromise<IGetIrregularOceanStudents> => {
  return axios.get(`${uri}/irregular-exam`);
}
